import React, { useState, useEffect, use } from 'react';
import { usersRestaurant } from '../api/users';
import { Me } from '../api/users';
import { getAllCombo, getFoodName, createCombo, createFieldCombo, getAllFood, AddFoodForField, CreateFood } from '../api/food';
import { getAllFieldsCombo } from '../api/food';
import { UpdateUser } from '../api/users';




const ChangeYourPassword = ({ token }) => {

    const [passwordOne, setPasswordOne] = useState('')
    const [passwordTwo, setPasswordTwo] = useState('')
    const [errorMessage, setErrorMessage] = useState(['', 'red', false])
    const [user, setUser] = useState(null)
    const [message, setMessage] = useState('')

    const [allCombo, setAllCombo] = useState([])
    const [allFieldsCombo, setAllFieldsCombo] = useState([])
    const [allFoodFieldsCombo, setAllFoodFieldsCombo] = useState([])
    const [nameNewCombo, setNameCombo] = useState('')
    const [minHoursNewCombo, setMinHoursCombo] = useState('')
    const [nameNewFieldCombo, setNameNewFieldCombo] = useState('')
    const [selectedCombo, setSelectedCombo] = useState('')
    const [selectedFood, setSelectedFood] = useState('')
    const [allFood, setAllFood] = useState([])
    const [fieldComboSelected, setFieldComboSelected] = useState('')
    const [newFood, setNewFood] = useState('')


    


    const loadAllCombo = async () => {
        try {
            const user = await Me(token)
            setUser(user)
        } catch (err) {
            console.error(err);
        }
    };
      
    useEffect(() => {
    
        loadAllCombo();
    }, [token]);
    
    function changePasswordOne(e){
        let value = e.target.value
        setPasswordOne(value)
        if (value != passwordTwo){
            setErrorMessage(['Пароли не совпадают!', 'red' , false])
        }
        else if (value.length < 8){
            setErrorMessage(['Длина пароля меньше 8!','red', false])
        }
        else {
            setErrorMessage(['все гуд!', 'green', true])
        }
    }

    function changePasswordTwo(e){
        let value = e.target.value
        setPasswordTwo(value)
        if (value != passwordOne){
            setErrorMessage(['Пароли не совпадают!','red', false])
        }
        else if (value.length < 8){
            setErrorMessage(['Длина пароля меньше 8!','red', false])
        }
        else {
            setErrorMessage(['все гуд!', 'green', true])
        }
    }


    async function editPassword(e){
        const data = await UpdateUser(token, user.id, {'hashed_password': passwordOne})
        if (data.detail){
            setMessage(data.detail)
            return
        }
        setMessage(`Пароль изменен!`)
    }

    
          
    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-6 offset-sm-3">
                    <h2 className='text-center' style={{marginTop: "15%"}}>Смена пароля</h2>
                    <form action="" style={{marginTop: "10%"}} onSubmit={(e) => e.preventDefault()}>
                        <div className="desctiption">
                            <p className='text-center'>Пароль должен быть не меньше 8 символов!</p>
                        </div>
                        <div className="password-1">
                            <input type="password" className="form-control" value={passwordOne} onChange={changePasswordOne}/>
                            <p className='text-center'>Новый пароль</p>
                        </div>
                        <div className="password-2">
                            <input type="password" className="form-control" value={passwordTwo} onChange={changePasswordTwo}/>
                            <p className='text-center'>Подтверждение пароля</p>
                        </div>
                        <div className="error-message">
                            <p className='text-center' style={{color: errorMessage[1]}}>{errorMessage[0]}</p>
                        </div>
                        { errorMessage[2] && (
                            <div className="btn-send text-center">
                                <button className='btn' type='button' onClick={editPassword} data-bs-toggle="modal" data-bs-target="#exampleModal">Изменить!</button>
                            </div>
                        )}
                        
                        
                    </form>
                </div>
            </div>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Информация</h1>
                    </div>
                    <div className="modal-body">
                        {message}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangeYourPassword